/** Build a unique "Name (copy)" label for duplicating a location shell. */
export function nextLocationCopyName(sourceName: string, existingNames: string[]): string {
  const trimmed = sourceName.trim() || 'Location';
  const base = trimmed.replace(/\s*\(copy(?:\s+\d+)?\)$/i, '').trim() || trimmed;
  const names = new Set(existingNames.map((name) => name.trim().toLowerCase()));

  const first = `${base} (copy)`;
  if (!names.has(first.toLowerCase())) return first;

  let n = 2;
  while (names.has(`${base} (copy ${n})`.toLowerCase())) n += 1;
  return `${base} (copy ${n})`;
}
